import { memo } from "react";
import {
    GRID_ACTIONS_COLUMN_TYPE,
    GridActionsCellItem,
    type GridRowParams
} from "@mui/x-data-grid-premium";
import EditIcon from '@mui/icons-material/Edit';
import ResourceLayout from "ui/layouts/Resource";
import { Resource, ResourceProvider } from "ui/widgets/Resource";
import type { OpenBankingResourceProps } from "./types";
import { useOpenBankingResource } from "./hooks";

const OpenBankingResource = ({
    BreadcrumbsProps,
    ResourceProps
}: OpenBankingResourceProps) => {
    const {
        onOpen,
        getRowId
    } = useOpenBankingResource();

    return (
        <ResourceLayout
            breadcrumbsProps={{
                heading: 'Open Banking',
                links: [{ name: '' }],
                ...BreadcrumbsProps,
                sx: {
                    mb: 0,
                    ...BreadcrumbsProps?.sx
                }
            }}
        >
            <Resource
                {...ResourceProps}
                FiltersProps={{
                    ...ResourceProps.FiltersProps,
                    sx: {
                        m: 0,
                        ...ResourceProps.FiltersProps?.sx
                    }
                }}
                LayoutProps={{
                    sx: {
                        m: '24px 0px'
                    }
                }}
                getRowId={getRowId}
                initialState={{
                    pinnedColumns: {
                        right: [GRID_ACTIONS_COLUMN_TYPE]
                    }
                }}
                columns={[
                    {
                        field: GRID_ACTIONS_COLUMN_TYPE,
                        type: GRID_ACTIONS_COLUMN_TYPE,
                        getActions: ({ row }: GridRowParams) => [
                            <GridActionsCellItem
                                onClick={() => onOpen(row)}
                                icon={<EditIcon />}
                                label='Edit'
                                data-test-id={`openBanking.table.row.${row.coreId ?? row.id}.actions.edit`}
                            />
                        ]
                    },
                    ...ResourceProps.columns ?? []
                ]}
            />
        </ResourceLayout>
    );
};

export default memo((props: OpenBankingResourceProps) => (
    <ResourceProvider>
        <OpenBankingResource
            {...props}
        />
    </ResourceProvider>
));
